import * as React from "react";
import useSWR from "swr";
import fetcher from "./fetcher";

const baseEndpoint = "/api/autographPurchase/user/byReceiptNumber";

export default function useOrderByReceiptNumber(receiptNumber = null) {
  const url = receiptNumber ? `${baseEndpoint}/${receiptNumber}` : null;

  const { data, error, mutate } = useSWR(url, fetcher);

  const order = React.useMemo(() => {
    if (!data?.order) {
      return null;
    }
    return data.order;
  }, [data]);

  return {
    order,
    isLoading: !order && !error,
    isError: Boolean(error),
    error,
    refresh: mutate,
  };
}
